<app-header></app-header>
<ngx-spinner></ngx-spinner>
<div class="wrapper">
  <section class="content-banner">
    <div class="container">
      <h1 class="text-capitalize">
        {{ "CONTACTUS.GET_IN_TOUCH" | translate }}
      </h1>
      <!-- <p class="m-0">
        {{ "CONTACTUS.MESSAGE" | translate }}
      </p> -->
    </div>
  </section>
  <section class="contect-us">
    <div class="container">
      <div class="detail-box row">
        <div class="other-info">
          <h4 class="">{{ "CONTACTUS.CONTACT_INFORMATION" | translate }}</h4>
          <div class="w-100 p-3">
            <div class="form-group">
              <strong>
                <span class="mdi mdi-map-marker"> </span>
                {{ "CONTACTUS.ADDRESS" | translate }}:
              </strong>
              <p class="mb-0">{{ "CONTACTUS.FULL_ADDRESS" | translate }}</p>
            </div>
            <div class="form-group">
              <strong>
                <span class="mdi mdi-phone"> </span>
                {{ "CONTACTUS.PHONE" | translate }}:
              </strong>
              <p class="mb-0">{{ "CONTACTUS.PHONE_NUMBER" | translate }}</p>
            </div>
            <div class="form-group">
              <strong>
                <span class="mdi mdi-email"></span>
                {{ "CONTACTUS.EMAIL" | translate }}:
              </strong>
              <p class="mb-0">
                <a
                  href="javascript:void(0)"
                  class="text-white"
                  target="_blank"
                  href="mailto:info@intelligens.com"
                >
                  {{ "CONTACTUS.EMAIL_ID" | translate }}
                </a>
              </p>
            </div>
          </div>
        </div>
        <div class="profile">
          <h4>
            {{ "CONTACTUS.CONTACT_US" | translate }}
          </h4>
          <form
            class="p-3"
            (ngSubmit)="
              resetPasswordForm.form.valid && contactUsForm(resetPasswordForm)
            "
            #resetPasswordForm="ngForm"
            role="form"
          >
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="form-group position-relative password-in label-ic">
                  <label>{{ "CONTACTUS.NAME" | translate }}</label>
                  <input
                    maxlength="30"
                    type="text"
                    name="name"
                    class="form-control"
                    pattern="^[a-zA-Z ]*$"
                    placeholder="{{ 'CONTACTUS.PLACEHOLDER_NAME' | translate }}"
                    [(ngModel)]="model.name"
                    #name="ngModel"
                    required
                  />
                  <div
                    style="color: red"
                    class="validation_div"
                    *ngIf="
                      name.errors &&
                      (name.dirty ||
                        name.touched ||
                        resetPasswordForm.submitted)
                    "
                  >
                    <p class="mb-0" *ngIf="name.errors.required">
                      {{ "CONTACTUS.NAME_REQUIRED" | translate }}
                    </p>
                    <p class="mb-0 red-text" *ngIf="name.errors.pattern">
                      {{ "CONTACTUS.INVALID_NAME" | translate }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group position-relative password-in label-ic">
                  <label>{{ "CONTACTUS.PHONE" | translate }}</label>
                  <input
                    maxlength="15"
                    type="number"
                    name="mobile"
                    class="form-control"
                    placeholder="{{
                      'CONTACTUS.PLACEHOLDER_MOBILE' | translate
                    }}"
                    [(ngModel)]="model.mobile"
                    #mobile="ngModel"
                    required
                    pattern="^[1-9][0-9]{9,14}$"
                  />
                  <div
                    style="color: red"
                    class="validation_div"
                    *ngIf="
                      mobile.errors &&
                      (mobile.dirty ||
                        mobile.touched ||
                        resetPasswordForm.submitted)
                    "
                  >
                    <p class="mb-0" *ngIf="mobile.errors.required">
                      {{ "CONTACTUS.MOBILE_REQUIRED" | translate }}
                    </p>
                    <p class="mb-0 red-text" *ngIf="mobile.errors.pattern">
                      {{ "CONTACTUS.ENTER_VALID_NUMBER" | translate }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group position-relative password-in label-ic">
                  <label> {{ "CONTACTUS.EMAIL" | translate }}</label>
                  <input
                    maxlength="255"
                    type="email"
                    name="email"
                    class="form-control"
                    placeholder="{{
                      'CONTACTUS.PLACEHOLDER_EMAIL' | translate
                    }}"
                    [(ngModel)]="model.email"
                    #email="ngModel"
                    required
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}$"
                  />
                  <div
                    style="color: red"
                    class="validation_div"
                    *ngIf="
                      email.errors &&
                      (email.dirty ||
                        email.touched ||
                        resetPasswordForm.submitted)
                    "
                  >
                    <p class="mb-0" *ngIf="email.errors.required">
                      {{ "CONTACTUS.EMAIL_REQUIRED" | translate }}
                    </p>
                    <p class="mb-0 red-text" *ngIf="email.errors.pattern">
                      {{ "CONTACTUS.ENTER_VALID_EMAIL" | translate }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group position-relative password-in label-ic">
                  <label>{{ "CONTACTUS.SUBJECT" | translate }}</label>
                  <input
                    maxlength="255"
                    type="text"
                    name="subject"
                    class="form-control"
                    placeholder="{{
                      'CONTACTUS.PLACEHOLDER_SUBJECT' | translate
                    }}"
                    [(ngModel)]="model.subject"
                    #subject="ngModel"
                    required
                  />
                  <div
                    style="color: red"
                    class="validation_div"
                    *ngIf="
                      subject.errors &&
                      (subject.dirty ||
                        subject.touched ||
                        resetPasswordForm.submitted)
                    "
                  >
                    <p class="mb-0" *ngIf="subject.errors.required">
                      {{ "CONTACTUS.SUBJECT_REQUIRED" | translate }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12">
                <div class="form-group position-relative password-in label-ic">
                  <label>{{ "CONTACTUS.DESCRIPTION" | translate }} </label>
                  <textarea
                    maxlength="1000"
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    placeholder="{{
                      'CONTACTUS.PLACEHOLDER_DESCRIPTION' | translate
                    }}"
                    rows="4"
                    name="message"
                    #message="ngModel"
                    [(ngModel)]="model.message"
                    required
                  ></textarea>
                  <div
                    style="color: red"
                    class="validation_div"
                    *ngIf="
                      message.errors &&
                      (message.dirty ||
                        message.touched ||
                        resetPasswordForm.submitted)
                    "
                  >
                    <p class="mb-0" *ngIf="message.errors.required">
                      {{ "CONTACTUS.DESCRIPTION_REQUIRED" | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <recaptcha
                [(ngModel)]="myRecaptcha"
                (scriptLoad)="onScriptLoad()"
                (scriptError)="onScriptError()"
                name="myRecaptcha"
              ></recaptcha>
              <div class="validation_div">
                <p class="mb-0" *ngIf="cMessage && resetPasswordForm.submitted">
                  {{ cMessage }}
                </p>
                <p
                  style="color: red"
                  class="mb-0"
                  *ngIf="
                    !myRecaptcha && resetPasswordForm.submitted && !cMessage
                  "
                >
                  {{ "CONTACTUS.SELECT_CAPTCHA" | translate }}
                </p>
              </div>
            </div>
            <div class="pt-3">
              <button type="submit" class="btn btn-theme">
                {{ "CONTACTUS.SUBMIT" | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>
<app-footer></app-footer>
